import { W as WuiStatus$1, d as defineCustomElement$1 } from './p-DT9iU5If.js';

const WuiStatus = WuiStatus$1;
const defineCustomElement = defineCustomElement$1;

export { WuiStatus, defineCustomElement };
